var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOutlineLock64Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32C0 14.3269 14.3269 0 32 0V0C49.6731 0 64 14.3269 64 32V32C64 49.6731 49.6731 64 32 64V64C14.3269 64 0 49.6731 0 32V32Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26H39.5V23C39.5 18.86 36.14 15.5 32 15.5C27.86 15.5 24.5 18.86 24.5 23V26H23C21.35 26 20 27.35 20 29V44C20 45.65 21.35 47 23 47H41C42.65 47 44 45.65 44 44V29C44 27.35 42.65 26 41 26ZM27.5 23C27.5 20.51 29.51 18.5 32 18.5C34.49 18.5 36.5 20.51 36.5 23V26H27.5V23ZM41 44H23V29H41V44ZM32 39.5C33.65 39.5 35 38.15 35 36.5C35 34.85 33.65 33.5 32 33.5C30.35 33.5 29 34.85 29 36.5C29 38.15 30.35 39.5 32 39.5Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineLock64Px);
export default __webpack_public_path__ + "static/media/ic_outline-lock-64px.480b569dae5b40319de8b1dcce3279ec.svg";
export { ForwardRef as ReactComponent };